module.exports = __webpack_public_path__ + "static/4-a6c381a878bc45ba37df4725f944e117.png";